// extracted by css-extract-rspack-plugin
export default {"wrapper":"_b760b521"};